/**
 * Chuỗi của màn Trợ lý Agent RPA (`/rpa/agent`). Câu chữ lấy từ namespace `rpa.agent` của web-portal native, đổi sang
 * kiểu dấu thanh mới. Tạm tách tệp, sẽ gộp vào `vi.ts`.
 */
export const viRpaAgent = {
  rpaAgent: {
    moTa: 'Giao việc cho agent (Hermes / OpenClaw) đọc dữ liệu OpenRPA, báo cáo lỗi và đề xuất cách xử lý.',
    daGiao: 'Đã giao việc cho agent. Kết quả hiện trong danh sách khi agent xử lý xong.',
    phamViNgay: '{{so}} ngày gần nhất',
    ketNoi: {
      daKetNoi: 'Đã kết nối agent',
      danhSach: 'Agent sẵn sàng: {{ds}}',
      chuaCauHinh: 'Chưa cấu hình',
      chuaCauHinhGoiY: 'Máy chủ RPA chưa có RPA_AGENT_GATEWAY_URL và RPA_AGENT_GATEWAY_KEY. Liên hệ quản trị hệ thống.',
      khongKetNoi: 'Không kết nối được',
      khongKetNoiGoiY: 'Không gọi được Agent Gateway. Kiểm tra máy chủ agent và đường mạng (VPN, tường lửa).',
    },
    mauNhan: {
      errors: 'Phân tích lỗi',
      overview: 'Tóm tắt vận hành',
      retry: 'Đề xuất chạy lại',
    },
    mauNoiDung: {
      errors:
        'Phân tích các lượt chạy lỗi và bị huỷ: Workflow nào lỗi nhiều nhất, lỗi ở bước nào, nguyên nhân có thể và cách xử lý.',
      overview:
        'Tóm tắt tình hình vận hành RPA: số lượt chạy và tỷ lệ thành công theo từng Workflow, máy nào chạy nhiều nhất, điểm cần chú ý.',
      retry:
        'Liệt kê các lượt chạy lỗi có thể chạy lại an toàn (lỗi tạm thời như quá thời gian, mạng, tệp đang bị khoá) và đề xuất chạy lại.',
    },
    form: {
      tieuDe: 'Giao việc cho agent',
      moTa: 'Agent đọc lượt chạy, sự cố và Workflow từ OpenCore trong phạm vi đã chọn.',
      khongCoQuyen: 'Bạn chưa được giao việc cho agent',
      khongCoQuyenMoTa: 'Cần quyền {{quyen}}. Bạn vẫn xem được các task và kết quả ở danh sách bên cạnh.',
      chuaKetNoi: 'Chưa giao việc được khi Agent Gateway chưa kết nối.',
      mauNhanh: 'Mẫu yêu cầu nhanh',
      agent: 'Agent',
      phamVi: 'Phạm vi dữ liệu',
      phamViGoiY: 'Khoảng thời gian lượt chạy gửi kèm cho agent.',
      yeuCau: 'Yêu cầu',
      yeuCauGoiY: 'Mô tả việc cần agent làm. Agent chỉ đọc dữ liệu và đề xuất, không tự chạy Robot.',
      yeuCauMau: 'Ví dụ: Tuần này luồng TOPCV v2 lỗi mấy lần, lỗi ở bước nào?',
      batBuoc: 'Nhập nội dung yêu cầu cho agent.',
      quaDai: 'Yêu cầu dài quá {{max}} ký tự.',
      gui: 'Gửi cho agent',
      dangGui: 'Đang gửi...',
    },
    ds: {
      tieuDe: 'Task đã giao',
      moTa: '50 task gần nhất',
      daTai: '{{so}} task gần nhất (tối đa 50). Tự cập nhật khi có task đang chạy.',
      rong: 'Chưa có task nào',
      rongMoTa: 'Giao việc đầu tiên ở khung bên cạnh, ví dụ chọn mẫu “Phân tích lỗi”.',
      cotThoiGian: 'Thời gian',
      cotYeuCau: 'Yêu cầu',
      cotAgent: 'Agent',
      cotTrangThai: 'Trạng thái',
      cotThoiLuong: 'Thời lượng',
      xem: 'Xem kết quả',
      daCho: 'Đã chờ {{tg}}',
    },
    huy: {
      nut: 'Huỷ task',
      tieuDe: 'Huỷ task đang xử lý?',
      than: 'Task dừng và giải phóng chỗ ngay. Yêu cầu đã gửi cho agent có thể vẫn chạy tiếp ở phía agent. Thao tác không hoàn tác được.',
      daHuy: 'Đã huỷ task.',
    },
    trangThai: {
      running: 'Đang xử lý',
      completed: 'Hoàn tất',
      failed: 'Lỗi',
    },
    hanhDong: {
      retry_run: 'Chạy lại lượt',
      run_workflow: 'Chạy Workflow',
      check_robot: 'Kiểm tra máy',
      review_workflow: 'Rà soát Workflow',
    },
    chiTiet: {
      tieuDe: 'Chi tiết task agent',
      trangThai: 'Trạng thái',
      agent: 'Agent',
      phamVi: 'Phạm vi dữ liệu',
      giaoLuc: 'Thời gian giao',
      thoiLuong: 'Thời lượng xử lý',
      yeuCau: 'Yêu cầu',
      dangXuLy: 'Agent đang xử lý. Kết quả tự hiện khi xong.',
      loi: 'Agent không xử lý được yêu cầu',
      baoCao: 'Báo cáo của agent',
      deXuat: 'Hành động đề xuất ({{so}})',
      khongDeXuat: 'Agent không đề xuất hành động nào.',
      moMan: 'Mở màn liên quan',
      ghiChu:
        'Đây là đề xuất của agent, không tự chạy. Chỉ người có quyền thực thi mới chạy được, sau khi kiểm tra và xác nhận từng hành động.',
    },
    thucThi: {
      thucThi: 'Thực thi',
      kiemTra: 'Kiểm tra ngay',
      thuLai: 'Thử lại',
      tieuDeChay: 'Chạy Workflow agent đề xuất?',
      tieuDeChayLai: 'Chạy lại lượt lỗi?',
      nutChay: 'Chạy Workflow',
      nutChayLai: 'Chạy lại lượt',
      hanhDong: 'Hành động',
      workflow: 'Workflow sẽ chạy',
      luotLoi: 'Lượt lỗi',
      luotLoiLuc: 'Thời điểm lỗi',
      lyDo: 'Lý do của agent',
      robot: 'Robot chạy',
      robotCuaBan: '{{ten}} (tài khoản OpenCore bạn đã kết nối)',
      robotLicense: 'Robot theo License của Project',
      project: 'Project',
      projectGoiY: 'Chỉ hiện Project được gán Workflow này và có License còn hiệu lực.',
      chonProject: 'Chọn Project',
      khongCoProject:
        'Không có Project nào vừa được gán Workflow này vừa có License còn hiệu lực. Kiểm tra License và gán Workflow ở màn Project.',
      ghiChuChay: 'Robot sẽ chạy thật ngay sau khi xác nhận. Hành động này chỉ thực thi được một lần.',
      ghiChuChayLai:
        'Workflow chạy lại với dữ liệu đầu vào của lượt lỗi. Robot sẽ chạy thật ngay sau khi xác nhận và chỉ thực thi được một lần.',
      daGuiChay: 'Đã gửi lệnh chạy Workflow. Theo dõi kết quả ở màn Lịch sử luồng chạy.',
      daGuiChayLai: 'Đã gửi lệnh chạy lại. Theo dõi kết quả ở màn Lịch sử luồng chạy.',
      daKiem: 'Đã kiểm tra Robot.',
      dangChay: 'Đang thực thi...',
      loi: 'Thực thi lỗi',
      daXong: 'Đã thực thi',
      luc: 'lúc {{luc}}',
      xemLichSu: 'Xem lịch sử luồng chạy',
      robotDong: 'Robot {{ten}} · máy {{may}} · trạng thái {{tt}}',
      tkBat: 'tài khoản OpenCore đang bật',
      tkKhoa: 'tài khoản OpenCore đã bị khoá',
      tkKhongRo: 'không đọc được trạng thái tài khoản OpenCore',
    },
  },
} as const;
